import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import withLifecycles from 'async-lifecycles';
import {Button, Form, Header, Message} from 'semantic-ui-react';
import produce from 'immer';

import {FormWrapper, Wrapper} from './Layout';
import {FormattedMessage} from '../i18n/Context';
import api from '../../store/services/api';
import {ErrorMessages} from '../form-components/ErrorMessages';

class CompleteRegistration extends React.Component {
  state = {
    loading: false,
    error: {},
    newPassword: '',
    confirmPassword: '',
  };
  _mutateState = mutationFn => {
    this.setState(produce(mutationFn));
  };
  _handleInputChanged = (event, {name, value}) => {
    this._mutateState(state => {
      state[name] = value;
    });
  };
  _resetPassword = () => {
    const {token} = this.props.match.params;
    const {newPassword, confirmPassword} = this.state;
    withLifecycles(
      () => {
        return api.patch(`/accounts/forgot-password/complete/${token}`, {
          newPassword,
          confirmPassword,
        });
      },
      ({loading, data, error}) => {
        this.setState({loading, data, error});
      },
    );
  };

  render() {
    const {loading, newPassword, confirmPassword, data, error} = this.state;
    return (
      <Wrapper>
        <Header textAlign="center">
          <img
            src={`${process.env.PUBLIC_URL}/mm_logo.png`}
            alt="M&M International"
          />
        </Header>
        <FormWrapper attached loading={loading}>
          <Header textAlign="center">
            <FormattedMessage id="resetPassword.form.header" />
          </Header>
          {data &&
            !data.hasErrors && (
            <Fragment>
              <Message success>
                <FormattedMessage id="resetPassword.form.link.success" />
              </Message>
              <Button as={Link} to="/account/login" fluid primary>
                <FormattedMessage id="resetPassword.form.link.returnToLogin" />
              </Button>
            </Fragment>
          )}
          {(!data || data.hasErrors) && (
            <Form onSubmit={this._resetPassword}>
              <Form.Field>
                <FormattedMessage id="resetPassword.form.newPassword" />
                <Form.Input
                  type="password"
                  name="newPassword"
                  value={newPassword}
                  onChange={this._handleInputChanged}
                  autoFocus
                />
              </Form.Field>
              <Form.Field>
                <FormattedMessage id="resetPassword.form.confirmPassword" />
                <Form.Input
                  type="password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={this._handleInputChanged}
                />
              </Form.Field>
              <ErrorMessages error={error} />
              <div className="stacked-buttons">
                <Button type="submit" primary fluid>
                  <FormattedMessage id="resetPassword.form.button.submit" />
                </Button>
              </div>
            </Form>
          )}
        </FormWrapper>
      </Wrapper>
    );
  }
}

export default CompleteRegistration;
